<header class="page-header">
  <div>
    <h1>Manutenzioni</h1>
    <p>Elenco interventi programmati, dovuti e completati</p>
  </div>
  <button type="button" class="primary" (click)="showForm.set(!showForm())">
    {{ showForm() ? 'Annulla' : 'Programma intervento' }}
  </button>
</header>

<div class="toolbar">
  <label>
    Stato
    <select [(ngModel)]="filterStatus" (ngModelChange)="reload()">
      <option value="">Tutti</option>
      <option value="pending">pending</option>
      <option value="scheduled">scheduled</option>
      <option value="overdue">overdue</option>
      <option value="done">done</option>
    </select>
  </label>
</div>

@if (showForm()) {
  <form class="form-panel" (ngSubmit)="create()">
    <label>
      Macchinario
      <select [(ngModel)]="form.machine_id" name="machine_id" required>
        @for (m of machines(); track m.id) {
          <option [value]="m.id">{{ m.name }}</option>
        }
      </select>
    </label>
    <label>Titolo <input [(ngModel)]="form.title" name="title" required /></label>
    <label>Scadenza (dovuta) <input type="datetime-local" [(ngModel)]="form.due_at" name="due_at" /></label>
    <label>Programmata <input type="datetime-local" [(ngModel)]="form.scheduled_at" name="scheduled_at" /></label>
    <label class="full">Note <textarea [(ngModel)]="form.notes" name="notes" rows="2"></textarea></label>
    <button type="submit" class="primary">Salva</button>
  </form>
}

<table class="data-table">
  <thead>
    <tr>
      <th>Intervento</th>
      <th>Macchinario</th>
      <th>Stato</th>
      <th>Scadenza</th>
      <th>Programmata</th>
      <th>Completata</th>
    </tr>
  </thead>
  <tbody>
    @for (t of tasks(); track t.id) {
      <tr>
        <td>{{ t.title }}</td>
        <td>
          <a [routerLink]="['/machines', t.machine_id]">{{ t.machine_name }}</a>
        </td>
        <td><span class="status" [attr.data-status]="t.status">{{ t.status }}</span></td>
        <td>{{ t.due_at ? (t.due_at | date: 'short') : '—' }}</td>
        <td>{{ t.scheduled_at ? (t.scheduled_at | date: 'short') : '—' }}</td>
        <td>{{ t.completed_at ? (t.completed_at | date: 'short') : '—' }}</td>
      </tr>
    }
  </tbody>
</table>
